import { isNil } from 'lodash';
import { isAfter } from 'date-fns';

const notRequired = (value, validate) => (value ? validate(value) : undefined);

export const required = value => (value === false || (!isNil(value) && value !== '') ? undefined : 'Povinné pole');

export const isNumber = value => notRequired(value, v => (isNaN(Number(v)) ? 'Musí být číslo' : undefined));

export const isPositive = (value: any) =>
  notRequired(value, v => (isNaN(Number(v)) ? 'Musí být číslo' : value < 0 ? 'Musí být kladné číslo' : undefined));

export const time = (value: any) => {
  const timeRegex: any = /^([01]\d|2[0-3]):?([0-5]\d)(:00)?$/;
  return timeRegex.test(value) ? undefined : 'Zadejte čas ve formátu HH:MM';
};

/* Validate two dates */
export const validateTwoDates = (values: any) => {
  const errors: any = {};
  if (values.from && values.to && isAfter(values.from, values.to)) {
    errors.to = 'Datum "do" nesmí předcházet datu "od"';
  }
  return errors;
};

export const requiredWithText = text => value =>
  value === false || (!isNil(value) && value !== '') ? undefined : text;

export const maxLength = length => value =>
  value.length <= length ? undefined : `Zadaná hodnota může obsahovat maximálně ${length} znaky`;

export const minLength = length => value =>
  value.length >= length ? undefined : `Zadaná hodnota musí obsahovat minimálně ${length} znaky`;

const PASSWORD_POLICY_MESSAGE = 'Heslo musí obsahovat malé písmeno, velké písmeno, číslici a speciální znak';

export const validatePasswordWithMinLength = (minPasswordLength: number) => (value: string) => {
  if (!value) {
    return undefined;
  }

  if (value.length < minPasswordLength) {
    return `Heslo musí obsahovat minimálně ${minPasswordLength} znaků`;
  }

  if (!/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/[0-9]/.test(value) || !/[^A-Za-z0-9]/.test(value)) {
    return PASSWORD_POLICY_MESSAGE;
  }

  return undefined;
};

export const validatePasswordPolicy = validatePasswordWithMinLength(12);

export const validateAdminPasswordPolicy = validatePasswordWithMinLength(22);

export const timeValidation = value => (!value || /(\d{1,2}:\d{1,2})/.test(value) ? '' : 'Nevalidní hodnota');

export const validatePasswordConfirm = (values: any) => {
  const errors: any = {};
  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Heslá se musí zhodovat';
  }
  return errors;
};



// WEBPACK FOOTER //
// ./src/utils/validators.ts